import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cprNummer' })
export class CprNummerPipe implements PipeTransform {
  transform(value: string | undefined): string | undefined {
    if (!value) return undefined;
    if (value.includes('-')) return value;
    if (value.length == 9) value = '0' + value;
    return value.slice(0, 6) + '-' + value.slice(6, 10);
  }
}
